<template>
  <thead>
    <tr>
      <td
        v-if="isColumnDisplayed('product')"
        style="width: 300px;"
      >
        Termék
      </td>
      <td
        v-if="isColumnDisplayed('productPackType')"
        style="width: 120px;"
      >
        Kiszerelés
      </td>
      <td
        v-if="isColumnDisplayed('supplier')"
        style="width: 150px;"
      >
        Beszállító
      </td>
      <td
        v-if="isColumnDisplayed('expirationDate')"
        style="width: 150px;"
      >
        Szavatossági idő
      </td>
      <td
        v-if="isColumnDisplayed('count')"
        style="width: 120px;"
      >
        Mennyiség
      </td>
      <td
        v-if="isColumnDisplayed('baseCount')"
        style="width: 130px;"
      >
        Számolt készlet
      </td>
      <td
        v-if="isColumnDisplayed('comment')"
        style="width: 130px;"
      >
        Megjegyzés
      </td>
      <td
        v-if="isColumnDisplayed('unitPrice')"
        style="width: 130px;"
      >
        Ár/db
      </td>
      <td
        v-if="isColumnDisplayed('netPrice')"
        style="width: 150px;"
      >
        Nettó ár
      </td>
      <td
        v-if="isColumnDisplayed('vat')"
        style="width: 80px;"
      >
        ÁFA
        <el-tooltip
          v-if="isVatZero"
          class="item"
          effect="dark"
          content="Külföldi szállító esetében az ÁFA 0%."
          placement="top"
        >
          <i class="el-icon-info"></i>
        </el-tooltip>
      </td>
      <td
        v-if="isColumnDisplayed('declutterReason')"
        style="width: 100px;"
      >
        Selejtezés oka
      </td>
    </tr>
  </thead>
</template>
<script>
  export default {
    props: {
      enabledColumns: {
        type: Array,
        default() {
          return ['product', 'productPackType', 'expirationDate', 'count', 'unitPrice', 'netPrice', 'vat'];
        },
        required: false,
      },
      isVatZero: {
        type: Boolean,
        default() {
          return false;
        },
        required: false,
      },
    },
    methods: {
      isColumnDisplayed(column) {
        return this.enabledColumns.includes(column);
      },
    },
  };
</script>
